/**
 * HR help text for the Transfer and Promotion module.
 *
 * These are not record edits. Once approved, a transfer rewrites the employee's
 * branch, location, department, line manager, and payroll; a promotion rewrites
 * their grade, designation, and job title and runs a full salary revision, which
 * generates arrears for every payroll month already closed since the effective
 * date and rebuilds their salary benefits from the new grade.
 */

const transfer = {
  employment_id: "Employee being transferred. Their approval workflow decides who receives the request.",
  date: "The date the transfer takes effect.",
  branch_id: "Branch the employee moves to. It replaces their current branch once approved.",
  location_id: "Location the employee moves to.",
  department_id: "Department the employee moves to. This changes their place in the department hierarchy, so it also changes who can see and approve their requests.",
  linemanager_id: "The employee's new approving manager. Their pending and future requests go to this person after the transfer.",
  payroll_id: "Payroll the employee moves onto. It changes their salary month, cut-off dates, and which payitems are calculated for them.",
  description: "Why the transfer is happening. Approvers read this before approving.",
  remarks: "Remarks added while approving or rejecting.",
  last_remarks: "Remarks written by the last approver. Visible in the request history.",
  remove_machine_employee: "When on, an approved transfer also removes the employee from the attendance machines. Use it when the employee is moving to a site with different machines; leaving it on for a local move stops their punches being recorded.",
};

const promotion = {
  employment_id: "Employee being promoted. Their approval workflow decides who receives the request.",
  date: "The date the promotion takes effect. A back-dated date makes payroll create arrears for every salary month already closed since then, with the first month split by days between the old and new salary.",
  grade_id: "Grade the employee moves to. Their salary benefits are rebuilt from this grade, so benefits attached to the old grade are removed.",
  grade_level_id: "Level within the new grade.",
  designation_id: "Designation the employee moves to.",
  job_title_id: "Job title the employee moves to, where it differs from the designation.",
  is_demotion: "Tick this when the change is a demotion rather than a promotion. It records the move correctly in history and reports.",
  prev_salary: "The employee's salary before this change, shown for reference.",
  salary: "The employee's new gross salary from the effective date. It replaces their current salary and drives every payroll formula from then on.",
  description: "Why the promotion is happening. Approvers read this before approving.",
  remarks: "Remarks added while approving or rejecting.",
  last_remarks: "Remarks written by the last approver. Visible in the request history.",
};

export const transferTooltips = { transfer, promotion };
export default transferTooltips;
